export const GRID_SIZE = { width: 50, height: 30 };

interface CanvasConfig {
  MAX_WIDTH: number;
  getHeight(width?: number): number;
  getCellSize(width?: number): number;
}

export const CANVAS: CanvasConfig = {
  MAX_WIDTH: 1024,

  getHeight(width = 1024): number {
    return Math.round(width * (GRID_SIZE.height / GRID_SIZE.width));
  },

  getCellSize(width = 1024): number {
    return width / GRID_SIZE.width;
  }
};

export const CELL_SIZE = CANVAS.getCellSize();

export const GAME_SPEED_MS = 150;
export const FOOD_VALUE = 1;
export const POWER_UP_SPAWN_INTERVAL = 5000;
export const POWERUP_SPAWN_CHANCE = 0.01;
export const POWER_UP_GRID_DURATION = 5000;
export const POWER_UP_EFFECT_DURATION = 30000;
export const POWERUP_DURATION_MS = 5000;

export const PLAYER_COLORS = [
  '#FF5733',
  '#33FF57',
  '#3357FF',
  '#FF33A1',
  '#FFDD33',
  '#33FFF3',
  '#FF8F33',
  '#8F33FF',
  '#FFFFFF',
  '#B2FF33',
  '#33FFB2',
  '#B233FF',

  '#1E293B',
  '#1E3A8A',
  '#3F005E',
  '#6B0000',
  '#3D4B12',
  '#004D40',

  '#FFD1DC',
  '#B5EAD7',
  '#C7CEEA',
  '#FFF1C1',
  '#E2F0CB',
  '#F0E0FF',

  '#F0A202',
  '#F87666',
  '#264653',
  '#8338EC',
  '#06D6A0',
  '#815AC0',
  '#FF6392',
  '#03071E',
  '#A7F0D1',
  '#540D6E'
];
